import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'top-wave',
  template: `
    <div class="wave2">
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 80">
        <path class="st0 index-last-wave" d="M685.6,56.38C418.7,6.48,170.2,27.48,0,47.58v137l1440-.07V47.58C1252.7,69.78,1010,117,685.6,56.38Z" transform="translate(0 -25.54)" />
      </svg>
    </div>
  `,
styleUrls: ['top-wave.less']
})
export class TopWaveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
